const richTextDetail = () =>
  import(/* webpackChunkName: "rich~text" */ 'page/richText/detail.vue')

let routes = [
  {
    name: 'richTextDetail',
    path: '/richtext/:code',
    component: richTextDetail
  }
]

export default routes
